var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6899",
    "data-name": "Group 6899",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.489,
    height: 21.262,
    viewBox: "0 0 17.489 21.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5193",
    "data-name": "Rectangle 5193",
    width: 17.489,
    height: 21.262,
    transform: "translate(0 0)",
    fill: "#003189"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6897",
    "data-name": "Group 6897",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9016",
    "data-name": "Path 9016",
    d: "M14.76,14.872a1.825,1.825,0,0,1-1.82-1.82v-.91a1.82,1.82,0,1,1,3.639-.085c0,.028,0,.057,0,.085v.91a1.824,1.824,0,0,1-1.819,1.82m-1.82,6.362,3.639.006a.912.912,0,0,0,.91-.91V18.51a2.73,2.73,0,0,0-5.459,0v1.82a.9.9,0,0,0,.9.9h.014Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9017",
    "data-name": "Path 9017",
    d: "M10.617,20.543a.717.717,0,0,0-.718-.718H3.3a1.808,1.808,0,0,1-1.866-1.738V3.174A1.806,1.806,0,0,1,3.3,1.436h8.918a1.807,1.807,0,0,1,1.866,1.738V8.687a.719.719,0,0,0,1.438,0V3.174A3.244,3.244,0,0,0,12.222,0H3.3A3.245,3.245,0,0,0,0,3.174V18.088a3.244,3.244,0,0,0,3.3,3.173H9.9A.717.717,0,0,0,10.617,20.543Z",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9018",
    "data-name": "Path 9018",
    d: "M7.518,3.807a.91.91,0,0,0-1.282,0L5.056,4.983l-.267-.267A.91.91,0,0,0,3.5,6l.91.91a.91.91,0,0,0,1.286,0l1.82-1.82a.91.91,0,0,0,0-1.286Zm0,5.459a.91.91,0,0,0-1.282,0L5.056,10.44l-.267-.267A.91.91,0,1,0,3.454,11.41c.016.017.032.033.049.049l.91.91a.91.91,0,0,0,1.286,0l1.82-1.82a.91.91,0,0,0,0-1.286Zm0,5.459a.91.91,0,0,0-1.286,0L5.056,15.9l-.267-.267A.91.91,0,1,0,3.47,16.887c.01.011.022.022.033.033l.91.91a.91.91,0,0,0,1.286,0l1.82-1.82a.91.91,0,0,0,0-1.286Z",
    fill: "#003189"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.bdf94ecc41c624b4e91204ce85f10f7f.svg";
export { ForwardRef as ReactComponent };